// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lp-grid-center-top-container {
    width: 100%;
    height: 400px;
    margin-top: -70px;  
}

  /* Cover Photo */
  .lp-cover-container {
    position: relative;
    height: 250px;
    width: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
  }
  
  .lp-profile-photo {
    position: absolute;
    bottom: -30px;
    left: 20px;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: bold;
  }
  
  /* Feed Navigation */
  .lp-feed-navigation {
    position: relative;
    height: 80px;
    width: 100%;
    max-width: 900px;
    display: flex;
    flex-direction: row;
    align-items: center;
    /* justify-content: center; */
    border-radius: 10px;
    margin-top: 0px;  
  }
  
    /* Feed Navigation */
    .lp-feed-navigation-first {
      position: relative;
      height: 70px;
      width: auto;
      max-width: 80%;
      background: none;
      display: flex;
      border-radius: 10px;
      margin-left: -30px;
    }

    /* Feed Navigation */
    .lp-feed-navigation-second {
      position: relative;
      height: 80px;
      width: 20%;
      background-color: none;
      display: flex;
      margin-top: 10px;
      justify-content: right;
      border-radius: 10px;
    }

    .lp-post-container {
      position: relative;
      height: 250px;
      max-width: 1000px;
      width: 100%;
      background-color: lightgray;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
      box-shadow: 0px 4px 6px gray;
    }

    .lp-post-container:hover {
      box-shadow: 1px 1px 1px white;
    }

  .lp-feed-navigation button {
    background-color: white;
    width: 130px;
    margin-top: 15px;
    color: black;
    border: black;
    padding: 10px 15px;
    border-radius: 30px;
    cursor: pointer;
  }

  .lp-expandable-button {
    margin-left: 30px;
    background-color: none;
    background: none;
    border: black;
    width: 170px;
    font-size: 16px;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    border: 1px solid black;
  }
  
  .lp-expandable-button:hover {
    width: 130px;
    box-shadow: 0 0 5px green;
  }

  .lp-post-options {
    position: relative;
    display: inline-block;
  }
  
  .lp-more-options-btn {
    background: rgb(245, 238, 238);
    margin-top: 20px;
    margin-left: 170px;
    width: 50px;
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
  }
  
  .lp-dropdown-menu {
    position: absolute;
    margin-right: -150px;
    top: 30px;
    right: 0;
    background: rgb(245, 238, 238);
    border: 1px solid #ddd;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    overflow: hidden;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-size: 18px;
  }
  
  .lp-dropdown-menu button {
    width: 100%;
    padding: 10px;
    border: none;
    background: rgb(245, 238, 238);
    cursor: pointer;
    text-align: left;
  }
  
  .lp-dropdown-menu button:hover {
    background: #f0f0f0;
  }

  .lp-post-container {
    width: 800px;
    height: 250px;
    max-height: 95%;
    max-width: 100%;
    padding: 15px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background: lightgray;    
    overflow-y: auto;
  }
  .lp-description-input {
    margin-left: 10px;
    height: 50%;
    width: 96%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    resize: none;
    overflow-y: auto;
  }

  .lp-submission-container {
    margin-top: 20px;
    margin-left: 9px;
    height: auto;
    width: 97%;
    max-width: 1000px;
    max-height: 60px;
    padding: 15px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background:rgb(245, 238, 238);
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    overflow-y: auto;
  }
  
  .lp-media-section {
    /* margin-top: 60px;
    margin-bottom: 0px; */
    width: 10%;
    margin-left: 10px;
    height: -10px;
    display: flex;
    align-items: center;
    gap: 10px;
    background: black;
  }
  
  .lp-upload-btn, .lp-post-btn {
    padding: 8px 12px;
    margin-right: 5px;
    width: 30px;
    height: 30px;
    font-size: 12px;
    background: #007bff;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 5px;
  }

  .lp-upload-btn {
    padding: 8px 12px;
    width: 70px;
    height: 30px;
    margin-top: -5px;
    align-items: center;
    font-family: puppins;
    font-size: 12px;
    margin-left: -50px;
    background: darkgray;
    color: black;
    border: none;
    cursor: pointer;
    border-radius: 10px;
  }
  
  .lp-post-btn {
    padding: 8px 12px;
    width: 65px;
    height: 30px;
    margin-top: -5px;
    align-items: center;
    font-family: puppins;
    font-size: 12px;
    margin-left: 150px;
    background: darkgray;
    color: black;
    border: none;
    cursor: pointer;
    border-radius: 10px;
  }

  .lp-upload-btn:hover, .lp-post-btn:hover {
    background: #0056b3;
  }
  
  .lp-uploaded-media {
    margin-top: 10px;
  }
  
  .lp-media-preview {
    display: inline-block;
    padding: 5px;
    margin: 3px;
    background: #f0f0f0;
    border-radius: 4px;
  }
  
  .lp-tab-button {
    padding: 10px 15px;
    border: none;
    color: black;
    cursor: pointer;
    transition: 0.3s;
  }
  
  .lp-tab-button:hover {
    background-color: #ddd; /* Hover effect */
  }
  
  .lp-active-tab {
    background-color: #6200ea !important; /* Highlight active tab */
    color: white !important;
    cursor: default; /* Make it non-clickable */
    font-weight: bold;
  }

  .lp-remove-btn {
    padding: 8px 12px;
    width: 65px;
    height: 30px;
    margin-top: -5px;
    align-items: center;
    font-family: puppins;
    font-size: 12px;
    margin-left: 150px;
    background: lightgray;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 10px;
    cursor: not-allowed; /* Show disabled cursor */
    opacity: 0.6;
  }
  
  .lp-remove-btn:not(:disabled) {
    background-color: darkgray;
    color: black;
    cursor: pointer;
    opacity: 1;
  }

  /* Main Feed */
.lp-main-feed {
  margin-top: 10px;
  width: 100%;
  border-radius: 10px;
  max-height: 1000vh;
  height: 300px;
}

.lp-main-feed-container {
  margin-top: 20px;
  width: 100%;
  border-radius: 20px;
  max-height: 1000vh;
  height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/PostPage/Styles/PPGridCenter.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;AACrB;;EAEE,gBAAgB;EAChB;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;EACnB;;EAEA,oBAAoB;EACpB;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;EACjB;;IAEE,oBAAoB;IACpB;MACE,kBAAkB;MAClB,YAAY;MACZ,WAAW;MACX,cAAc;MACd,gBAAgB;MAChB,aAAa;MACb,mBAAmB;MACnB,kBAAkB;IACpB;;IAEA,oBAAoB;IACpB;MACE,kBAAkB;MAClB,YAAY;MACZ,UAAU;MACV,sBAAsB;MACtB,aAAa;MACb,gBAAgB;MAChB,sBAAsB;MACtB,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;MAClB,aAAa;MACb,iBAAiB;MACjB,WAAW;MACX,2BAA2B;MAC3B,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,mBAAmB;MACnB,4BAA4B;IAC9B;;IAEA;MACE,6BAA6B;IAC/B;;EAEF;IACE,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,SAAS;IACT,QAAQ;IACR,8BAA8B;IAC9B,sBAAsB;IACtB,wCAAwC;IACxC,mBAAmB;IACnB,gBAAgB;IAChB,mJAAmJ;IACnJ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,eAAe;IACf,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,WAAW;IACX,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;IAC7B,0CAA0C;IAC1C,gBAAgB;EAClB;;EAEA;IACE;yBACqB;IACrB,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,sBAAsB,EAAE,iBAAiB;EAC3C;;EAEA;IACE,oCAAoC,EAAE,yBAAyB;IAC/D,uBAAuB;IACvB,eAAe,EAAE,0BAA0B;IAC3C,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,mBAAmB,EAAE,yBAAyB;IAC9C,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,YAAY;IACZ,eAAe;IACf,UAAU;EACZ;;EAEA,cAAc;AAChB;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd","sourcesContent":[".lp-grid-center-top-container {\n    width: 100%;\n    height: 400px;\n    margin-top: -70px;  \n}\n\n  /* Cover Photo */\n  .lp-cover-container {\n    position: relative;\n    height: 250px;\n    width: 400px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 10px;\n  }\n  \n  .lp-profile-photo {\n    position: absolute;\n    bottom: -30px;\n    left: 20px;\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    font-weight: bold;\n  }\n  \n  /* Feed Navigation */\n  .lp-feed-navigation {\n    position: relative;\n    height: 80px;\n    width: 100%;\n    max-width: 900px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    /* justify-content: center; */\n    border-radius: 10px;\n    margin-top: 0px;  \n  }\n  \n    /* Feed Navigation */\n    .lp-feed-navigation-first {\n      position: relative;\n      height: 70px;\n      width: auto;\n      max-width: 80%;\n      background: none;\n      display: flex;\n      border-radius: 10px;\n      margin-left: -30px;\n    }\n\n    /* Feed Navigation */\n    .lp-feed-navigation-second {\n      position: relative;\n      height: 80px;\n      width: 20%;\n      background-color: none;\n      display: flex;\n      margin-top: 10px;\n      justify-content: right;\n      border-radius: 10px;\n    }\n\n    .lp-post-container {\n      position: relative;\n      height: 250px;\n      max-width: 1000px;\n      width: 100%;\n      background-color: lightgray;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 10px;\n      box-shadow: 0px 4px 6px gray;\n    }\n\n    .lp-post-container:hover {\n      box-shadow: 1px 1px 1px white;\n    }\n\n  .lp-feed-navigation button {\n    background-color: white;\n    width: 130px;\n    margin-top: 15px;\n    color: black;\n    border: black;\n    padding: 10px 15px;\n    border-radius: 30px;\n    cursor: pointer;\n  }\n\n  .lp-expandable-button {\n    margin-left: 30px;\n    background-color: none;\n    background: none;\n    border: black;\n    width: 170px;\n    font-size: 16px;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    border: 1px solid black;\n  }\n  \n  .lp-expandable-button:hover {\n    width: 130px;\n    box-shadow: 0 0 5px green;\n  }\n\n  .lp-post-options {\n    position: relative;\n    display: inline-block;\n  }\n  \n  .lp-more-options-btn {\n    background: rgb(245, 238, 238);\n    margin-top: 20px;\n    margin-left: 170px;\n    width: 50px;\n    background: none;\n    border: none;\n    font-size: 20px;\n    cursor: pointer;\n  }\n  \n  .lp-dropdown-menu {\n    position: absolute;\n    margin-right: -150px;\n    top: 30px;\n    right: 0;\n    background: rgb(245, 238, 238);\n    border: 1px solid #ddd;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n    border-radius: 10px;\n    overflow: hidden;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n    font-size: 18px;\n  }\n  \n  .lp-dropdown-menu button {\n    width: 100%;\n    padding: 10px;\n    border: none;\n    background: rgb(245, 238, 238);\n    cursor: pointer;\n    text-align: left;\n  }\n  \n  .lp-dropdown-menu button:hover {\n    background: #f0f0f0;\n  }\n\n  .lp-post-container {\n    width: 800px;\n    height: 250px;\n    max-height: 95%;\n    max-width: 100%;\n    padding: 15px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    background: lightgray;    \n    overflow-y: auto;\n  }\n  .lp-description-input {\n    margin-left: 10px;\n    height: 50%;\n    width: 96%;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    resize: none;\n    overflow-y: auto;\n  }\n\n  .lp-submission-container {\n    margin-top: 20px;\n    margin-left: 9px;\n    height: auto;\n    width: 97%;\n    max-width: 1000px;\n    max-height: 60px;\n    padding: 15px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    background:rgb(245, 238, 238);\n    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n    overflow-y: auto;\n  }\n  \n  .lp-media-section {\n    /* margin-top: 60px;\n    margin-bottom: 0px; */\n    width: 10%;\n    margin-left: 10px;\n    height: -10px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    background: black;\n  }\n  \n  .lp-upload-btn, .lp-post-btn {\n    padding: 8px 12px;\n    margin-right: 5px;\n    width: 30px;\n    height: 30px;\n    font-size: 12px;\n    background: #007bff;\n    color: white;\n    border: none;\n    cursor: pointer;\n    border-radius: 5px;\n  }\n\n  .lp-upload-btn {\n    padding: 8px 12px;\n    width: 70px;\n    height: 30px;\n    margin-top: -5px;\n    align-items: center;\n    font-family: puppins;\n    font-size: 12px;\n    margin-left: -50px;\n    background: darkgray;\n    color: black;\n    border: none;\n    cursor: pointer;\n    border-radius: 10px;\n  }\n  \n  .lp-post-btn {\n    padding: 8px 12px;\n    width: 65px;\n    height: 30px;\n    margin-top: -5px;\n    align-items: center;\n    font-family: puppins;\n    font-size: 12px;\n    margin-left: 150px;\n    background: darkgray;\n    color: black;\n    border: none;\n    cursor: pointer;\n    border-radius: 10px;\n  }\n\n  .lp-upload-btn:hover, .lp-post-btn:hover {\n    background: #0056b3;\n  }\n  \n  .lp-uploaded-media {\n    margin-top: 10px;\n  }\n  \n  .lp-media-preview {\n    display: inline-block;\n    padding: 5px;\n    margin: 3px;\n    background: #f0f0f0;\n    border-radius: 4px;\n  }\n  \n  .lp-tab-button {\n    padding: 10px 15px;\n    border: none;\n    color: black;\n    cursor: pointer;\n    transition: 0.3s;\n  }\n  \n  .lp-tab-button:hover {\n    background-color: #ddd; /* Hover effect */\n  }\n  \n  .lp-active-tab {\n    background-color: #6200ea !important; /* Highlight active tab */\n    color: white !important;\n    cursor: default; /* Make it non-clickable */\n    font-weight: bold;\n  }\n\n  .lp-remove-btn {\n    padding: 8px 12px;\n    width: 65px;\n    height: 30px;\n    margin-top: -5px;\n    align-items: center;\n    font-family: puppins;\n    font-size: 12px;\n    margin-left: 150px;\n    background: lightgray;\n    color: white;\n    border: none;\n    cursor: pointer;\n    border-radius: 10px;\n    cursor: not-allowed; /* Show disabled cursor */\n    opacity: 0.6;\n  }\n  \n  .lp-remove-btn:not(:disabled) {\n    background-color: darkgray;\n    color: black;\n    cursor: pointer;\n    opacity: 1;\n  }\n\n  /* Main Feed */\n.lp-main-feed {\n  margin-top: 10px;\n  width: 100%;\n  border-radius: 10px;\n  max-height: 1000vh;\n  height: 300px;\n}\n\n.lp-main-feed-container {\n  margin-top: 20px;\n  width: 100%;\n  border-radius: 20px;\n  max-height: 1000vh;\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
